module.exports = __webpack_public_path__ + "static/img/1_2_1_1.908bb7c3.jpg";